import React from 'react';

/**
 * Custom FormControlOption component for Blue Shield of California
 */
const CustomFormControlOption = props => {
  const { checked, styleOverrides = {}, ...rest } = props;

  // Create a custom style override that will override the formControlLabelRootSelected class
  const customStyleOverrides = {
    ...styleOverrides,
    label: {
      ...styleOverrides.label,
      // Override the rootClassName to prevent the default selected class from being applied
      rootClassName: checked ? 'custom-selected' : '',
      // Add inline styles to apply our custom selected state
      style: {
        ...(styleOverrides.label?.style || {}),
        backgroundColor: checked ? '#F8EDEB' : 'transparent',
        borderRadius: checked ? 4 : 0,
        transition: 'background-color 0.2s ease',
      },
    },
  };

  return (
    <>
      <style>
        {`
          .custom-selected {
            background-color: #F8EDEB !important;
            border-radius: 4px;
          }
        `}
      </style>
      <props.FormControlOption
        checked={checked}
        styleOverrides={customStyleOverrides}
        {...rest}
      />
    </>
  );
};

export default CustomFormControlOption;
